import { render } from "./VersionUpdateModal.vue?vue&type=template&id=b63fe740&scoped=true"
import script from "./VersionUpdateModal.vue?vue&type=script&lang=js"
export * from "./VersionUpdateModal.vue?vue&type=script&lang=js"

import "./VersionUpdateModal.vue?vue&type=style&index=0&id=b63fe740&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b63fe740"]])

export default __exports__